/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./AppText.vue?vue&type=template&id=1e5bb07e"
import script from "./AppText.ts?vue&type=script&lang=ts&external"
export * from "./AppText.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports